import cn from "classnames";
import { FormTemplate } from "components/modal/templates";
import { serializeReq } from "components/shared/form";
import { getInitialStateFromConfig } from "helpers/form";
import React from "react";
import { applyBookingComment } from "sources/books/trucks";

const config = {
    id: {},
    bookingComment: {
        label: "Комментарий",
        inputProps: { name: "bookingComment" },
        textarea: true,
        fieldWrapper: "col-sm-8 col-md-8",
        labelWrapper: "col-sm-4 col-md-4 col-form-label col-form-label-sm text-md-right text-sm-left",
    },
};

const initialState = getInitialStateFromConfig(config);

class BookingCommentForm extends FormTemplate {
    sendRequest = (stateData) => {
        return applyBookingComment(stateData);
    };

    renderBodyInner = () => {
        const { config } = this.props;
        return this.renderField(config.bookingComment);
    };

    deleteComment = () => {
        this.setState({ isLoading: true, isValid: true });
        return this.sendRequest(serializeReq({ id: this.props.carId, bookingComment: null })).then((res) => {
            if (res) {
                this.close(res);
            } else {
                this.setState({ isLoading: false, isValid: false });
            }
        });
    };

    renderFormActions = () => {
        const cname = cn("modal-window__footer", {
            "modal-window__footer--between": this.props.bookingComment,
            "modal-window__footer--right": !this.props.bookingComment,
        });
        return (
            <div className={cname}>
                {this.renderActionDelete()}
                {this.renderActionSend()}
            </div>
        );
    };

    renderActionDelete = () => {
        if (!this.props.bookingComment) {
            return null;
        }

        const cname = "btn btn-secondary btn-sm modal-window__footer-action mx-0";
        return (
            <div className={cname} onClick={this.deleteComment}>
                Удалить
            </div>
        );
    };

    renderActionSend = () => {
        const cname = "btn btn-brand btn-sm modal-window__footer-action mx-0";
        return <input type="submit" className={cname} value="Сохранить" />;
    };
}

const ConfiguredModal = (props) => {
    initialState.id = props.carId;
    initialState.bookingComment = props.bookingComment;
    return <BookingCommentForm {...props} config={config} initialState={initialState} />;
};

export default ConfiguredModal;
